
import { graphql } from 'react-apollo';

import { EmailMessage } from '../../../queries/EmailMessage';
import mapConnection from '../../../utils/connectionMapper';

const createDocumentsOptions = emailMessage =>
  emailMessage.documentsConnection
    ? mapConnection(emailMessage.documentsConnection)
    : [];

const withEmailMessage = graphql(EmailMessage, {
  options: props => ({
    variables: {
      id: props.task.emailMessage.id
    }
  }),
  props: ({ data: { emailMessage, refetch, loading, error } }) => ({
    error,
    emailMessageLoading: loading,
    emailMessageRefetch: refetch,
    emailMessage: emailMessage || {},
    documentsOptions: emailMessage ? createDocumentsOptions(emailMessage) : []
  })
});

export default withEmailMessage;



// WEBPACK FOOTER //
// ./src/component/tasks/AssignMessageTask/withEmailMessage.js